import {Step,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack} from '@mantine/core';


export const Profile = ({record}: { record: Step }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Display Name',
            value: record.displayName ?? '',
            span: 12,
        }, {
            label: 'Description',
            value: record.description ?? '',
            span: 12,
        }, {
            label: 'Position',
            value: typeof record.position === 'number' ? String(record.position) : '',
            span: 12,
        }];

    const executionProperties = [
        {
            label: 'Task State Name',
            value: record.taskStateName ?? '',
            span: 12,
        }, {
            label: 'Target Service',
            value: record.targetService ?? '',
            span: 12,
        }, {
            label: 'Target Operation',
            value: record.targetOperation ?? '',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateStep',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={executionProperties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
